// components/ParticularModal.js
import React, { useState, useEffect } from 'react';
import {
  Modal,Table,
  Form,
  Input,
  Switch,
  Select,
  Space,
  Button,
  message,
  Row,
  Col,
  Card,
  DatePicker,
  Alert,
  Spin,
  Tag
} from 'antd';
import {
  ScanOutlined,SearchOutlined,
  SignatureOutlined,
  UserOutlined,
  IdcardOutlined,
  CalendarOutlined,
  PhoneOutlined,
  MailOutlined,
  SaveOutlined,
  CloseOutlined,
  ReloadOutlined,
  HomeOutlined,
  CreditCardOutlined,
  TeamOutlined,
  FileTextOutlined
} from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';

import { BASE_URL } from '../utils/constants';
import LectorDNIMobile from './LectorDNIMobile'; // Importar el lector DNI
import doc from 'pdfkit';

const { Option } = Select;
const { TextArea } = Input;

const ParticularModal = ({
  visible,
  onClose,
  onSuccess,
  codigoHotel,
  numReserva,
  linea,
  numOcupante,
  codParti = null,
  nombreReserva = '',
  telefonoReserva = '',
  emailReserva = '',
  numHabitacion,
  fechaEntrada = null,
  tipoReserva = 'Hotel'
}) => {

        // console.log(" datos ParticularModal => ",numReserva,linea,numOcupante,codigoHotel);  

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [scanning, setScanning] = useState(false);
  const [currentCodParti, setCurrentCodParti] = useState(null);
  const [isNew, setIsNew] = useState(true);
  const [tipoAPI,setTipoAPI] = useState('')

  const [lectorVisible, setLectorVisible] = useState(false);
  const [lectorDNIVisible, setLectorDNIVisible] = useState(false);
  const [lineaSeleccionada, setLineaSeleccionada] = useState(null);

  // Estados para datos de combos
  const [paises, setPaises] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [tiposSexo, setTiposSexo] = useState([]);
  const [tiposCliente, setTiposCliente] = useState([]);
  const [tiposSegmentacion, setTiposSegmentacion] = useState([]);
  const [tiposEscaner, setTiposEscaner] = useState([]);

  const [modalBusquedaVisible, setModalBusquedaVisible] = useState(false);   
  const [filtroBusqueda, setFiltroBusqueda] = useState('');
  const [cargandoBusqueda, setCargandoBusqueda] = useState(false);  
  const [datosFiltrados, setDatosFiltrados] = useState([]);

  const [escanerSeleccionado, setEscanerSeleccionado] = useState(
        localStorage.getItem('escanerSeleccionado') || null
  );

  const [paginacionBusqueda, setPaginacionBusqueda] = useState({
      current: 1,
      pageSize: 10,
      total: 0
  });  


  const renderFlag = (codigoISO) => {
    if (!codigoISO || codigoISO.trim() === '') {
      return <span style={{ marginRight: '4px' }}>🌍</span>;
    }
    return <span className={`fi fi-${codigoISO.toLowerCase()}`} style={{ marginRight: '4px' }} />;
  };

  // Cargar datos de combos al montar
  useEffect(() => {
    if (visible) {
      fetchAuxData();
    }
  }, [visible]);


  // Cargar datos del particular cuando cambia el código
  useEffect(() => {
    if (visible && codParti && codParti !== '0' && codParti !== '') {
      loadParticular(codParti);
      setIsNew(false);
    } else {
      initializeFromReserva();
      setIsNew(true);
    }
  }, [visible, codParti]);

  // Cargar datos auxiliares (combos)
  const fetchAuxData = async () => {
    const token = localStorage.getItem('token');
    
    const endpoints = [
      { key: 'tiposEscaner', url: `${BASE_URL}/api/dni_delta/datosEscaner/todos`, setter: setTiposEscaner },      
      { key: 'paises', url: `${BASE_URL}/api/paises`, setter: setPaises },
      { key: 'provincias', url: `${BASE_URL}/api/particularesGC/aux/provincias`, setter: setProvincias },
      { key: 'tiposDocumento', url: `${BASE_URL}/api/particularesGC/aux/tipos-documento`, setter: setTiposDocumento },
      { key: 'tiposSexo', url: `${BASE_URL}/api/particularesGC/aux/tipos-sexo`, setter: setTiposSexo },
      { key: 'tiposCliente', url: `${BASE_URL}/api/particularesGC/aux/tipos-cliente`, setter: setTiposCliente },
      { key: 'tiposSegmentacion', url: `${BASE_URL}/api/particularesGC/aux/tipos-segmentacion`, setter: setTiposSegmentacion },
    ];

    for (const endpoint of endpoints) {
      try {
        const response = await axios.get(endpoint.url, {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 10000
        });
        const data = response.data.data || [];
        endpoint.setter(data);
      } catch (error) {
        console.error(`❌ Error cargando ${endpoint.key}:`, error.message);
        endpoint.setter([]);
      }
    }    
    
  };

  const abrirModalBusqueda = () => {
      setModalBusquedaVisible(true);
      setFiltroBusqueda('');
      buscarDatos( '', 1);
  };  

  const handleBuscarLocal = (e) => {
    const value = e.target.value;
    setFiltroBusqueda(value);
    
    buscarDatos(value, 1);
  };


  const handleCambiarEscaner = (value) => {
    setEscanerSeleccionado(value);
    localStorage.setItem('escanerSeleccionado', value);
  };    

  const buscarDatos = async (filtro = '', pagina = 1) => {
    setCargandoBusqueda(true);
    try {
      const token = localStorage.getItem('token');
      let url = '';
      
      const queryParams = new URLSearchParams({
        page: pagina,
        pageSize: paginacionBusqueda.pageSize,
        ...(filtro && { search: filtro })
      });

      url = `${BASE_URL}/api/particulares?${queryParams.toString()}`;

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` }
      });      
      
      console.log(" particualres => ",response.data.data);
      
      setDatosFiltrados(response.data.data || []); // Los datos ya vienen filtrados por el backend
      
      setPaginacionBusqueda({
        current: response.data.pagination?.currentPage || pagina,
        pageSize: response.data.pagination?.pageSize || paginacionBusqueda.pageSize,
        total: response.data.pagination?.totalRecords || 0
      });
      
    } catch (error) {
      console.error('Error buscando datos:', error);
      message.error('Error al buscar datos');
    } finally {
      setCargandoBusqueda(false);
    }
  };

  const seleccionarElemento = (elemento) => {
      // console.log(" seleccinarElemento => ",elemento);
    
      // console.log("elemento => ",elemento);
      const fechaExpedicion = elemento.FechaExpedicion ? dayjs(elemento.FechaExpedicion) : null;
      const fechaNacimiento = elemento.FechaNacimiento ? dayjs(elemento.FechaNacimiento) : null;        

      if (elemento.Codigo) { 
            setIsNew(false); 
            setCurrentCodParti(elemento.Codigo);
      }

      form.setFieldsValue({
          codparti: elemento.Codigo,
          Nombre: elemento.Nombre || 'HUESPED',
          TipoDocumento: elemento.TipoDocumento,
          NIF: elemento.NIF,
          NumeroSoporte: elemento.NumeroSoporte,
          FechaExpedicion: fechaExpedicion,
          FechaNacimiento: fechaNacimiento,
          Codigo: elemento.Codigo,
          Nombre1:elemento.nombre1,
          Apellido1: elemento.apellido1,
          Apellido2: elemento.apellido2,
          Sexo: elemento.Sexo,
          LugarNacimiento: elemento.LugarNacimiento,
          Nacionalidad: elemento.Nacionalidad,
          Direccion: elemento.Direccion,
          Poblacion: elemento.Poblacion,
          Provincia: elemento.Provincia,
          CodPostal: elemento.CodPostal,
          Telefono1: elemento.Telefono1,
          EMail: elemento.EMail,
          ListarDatos: elemento.ListarDatos,
          MarcaMailing: elemento.MarcaMailing,
          TipoCliente: elemento.TipoCliente,
          TipoSegmentacion: elemento.TipoSegmentacion,
          Notas: elemento.notas

      });
      form.setFieldValue('CodParti', elemento.Codigo);
      setModalBusquedaVisible(false);
    };  
  

  // Cargar un particular existente
  const loadParticular = async (codigo) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/particulares/${codigo}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = response.data.data;
      setCurrentCodParti(data.Codigo);

      const formValues = {
        Codigo: data.Codigo,
        Nombre1: data.nombre1 || '',
        Apellido1: data.apellido1 || '',
        Apellido2: data.apellido2 || '',
        NIF: data.NIF || '',
        NumeroSoporte: data.NumeroSoporte || '',
        Direccion: data.Direccion || '',
        Poblacion: data.Poblacion || '',
        CodPostal: data.CodPostal || '',
        Provincia: data.Provincia || '',
        Pais: data.Pais || '',
        LugarNacimiento: data.LugarNacimiento || '',
        FechaNacimiento: data.FechaNacimiento ? dayjs(data.FechaNacimiento) : null,
        FechaExpedicion: data.FechaExpedicion ? dayjs(data.FechaExpedicion) : null,
        TipoDocumento: data.TipoDocumento || '',
        Sexo: data.Sexo || '',
        TipoCliente: data.TipoCliente || '',
        TipoSegmentacion: data.TipoSegmentacion || '',
        Telefono1: data.Telefono1 || '',
        Telefono2: data.Telefono2 || '',
        Fax: data.Fax || '',
        EMail: data.EMail || '',
        Visa: data.visa || '',
        CadTarjeta: data.CadTarjeta ? dayjs(data.CadTarjeta) : null,
        Notas: data.notas || '',
        ListarDatos: Boolean(data.ListarDatos),
        MarcaMailing: Boolean(data.MarcaMailing),
        codparti: data.Codigo,
        Nombre: data.Nombre || 'HUESPED',
        TipoDocumento: data.TipoDocumento,
        Nacionalidad: data.Nacionalidad,
        PaisISO: data.PaisISO
                  
      };

      form.setFieldsValue(formValues);
      setIsNew(false);

    } catch (error) {
      console.error('❌ Error cargando particular:', error);
      message.error('Error al cargar los datos del particular');
    } finally {
      setLoading(false);
    }
  };

  // Inicializar con datos de la reserva
  const initializeFromReserva = () => {
    let nombre1 = '';
    let apellido1 = '';
    let apellido2 = '';

    form.resetFields();

    if (nombreReserva) {
      const parts = nombreReserva.trim().split(' ');
      if (parts.length === 1) {
        nombre1 = parts[0];
      } else if (parts.length === 2) {
        nombre1 = parts[0];
        apellido1 = parts[1];
      } else if (parts.length >= 3) {
        nombre1 = parts[0];
        apellido1 = parts[1];
        apellido2 = parts.slice(2).join(' ');
      }
    }

    form.setFieldsValue({
      Codigo: '',
      Nombre1: nombre1,
      Apellido1: apellido1,
      Apellido2: apellido2,
      Telefono1: telefonoReserva || '',
      EMail: emailReserva || '',
      ListarDatos: true,
      MarcaMailing: false,
    });

    setCurrentCodParti(null);
  };

  const parseFecha = (fecha) => {        
    if (!fecha) return null;
    
    const fechaStr = String(fecha).trim().padStart(8, '0');
    
    if (fechaStr.length !== 8 || !/^\d{8}$/.test(fechaStr)) {
      console.warn('Fecha con formato inválido:', fecha);
      return null;
    }
    
    const dia = fechaStr.substring(0, 2);
    const mes = fechaStr.substring(2, 4);
    const anio = fechaStr.substring(4, 8);
    
    return dayjs(`${anio}-${mes}-${dia}`);
  };

  const abrirLectorDNI = () => {
    console.log(escanerSeleccionado);
    setTipoAPI(escanerSeleccionado)
    if (escanerSeleccionado === 'Escaner'){            
      handleScan()
    }else if (escanerSeleccionado === 'API Delta'){
      setLectorDNIVisible(true);
    }else if (escanerSeleccionado === 'API Escaner'){
      setLectorDNIVisible(true);
    }  
    
  };

    const handleDNIProcesado = async (data) => {
        
      // console.log(" data => ",data);

        const getTipoDocumentoNombre = (codigo) => {
          const tipos = {
            'D': 'DNI',
            'P': 'PASAPORTE',
            'C': 'PERMISO CONDUCIR',
            'N': 'P. RESIDENCIA ESP',
            'X': 'P. RESIDENCIA EUR',
            'I': 'Carta Identidad'
          };
          return tipos[codigo] || codigo || '';
        };
        const getTipoSexo = (codigo) => {
          const tipos = {
            'M': 'HOMBRE',
            'F': 'MUJER',
          };
          return tipos[codigo] || codigo || '';
        };        

        console.log(" data => ",data);
        const token = localStorage.getItem('token');
        let urlParticular =  `${BASE_URL}/api/particulares/busqueda/${data.numero_documento}`;                
        
        const responseParticular = await axios.get(urlParticular, {
            headers: { Authorization: `Bearer ${token}` }
        });          

        // console.log(" responseParticular => ",responseParticular.data);

        if (responseParticular.data.success){                                
            seleccionarElemento(responseParticular.data.data);
        }else{        
            const formValues = {
              TipoDocumento: getTipoDocumentoNombre(data.tipo_documento),
              NIF: data.numero_documento || '',
              Nombre1: data.nombre || '',
              NumeroSoporte: data.numero_soporte,
              Apellido1: data.apellido1 || '',
              Apellido2: data.apellido2 || '',
              FechaNacimiento: parseFecha(data.fecha_nacimiento),
              FechaExpedicion: parseFecha(data.fecha_expedicion),
              FechaValidez: null,
              Nacionalidad: data.pais || '',
              Sexo: getTipoSexo(data.sexo),
              Direccion: data.domicilio || data.domicilio1 || '',
              Poblacion: data.domicilio2 || '',
              Provincia: data.domicilio3 || '',
              Comunidad: data.domicilio4 || '',
              CodPostal: data.codigo_ciudad || '',
              LugarNacimiento: data.localidad_nacimiento || '',          
              Pais: data.pais || '',
              
              // Poblacion: doc.domicilio2 || '',
              // CodPostal: doc.codigo_ciudad || '',               
              // PaisISO: doc.pais || '',          

              // codparti: elemento.Codigo,                    
            
            
              // Codigo: elemento.Codigo,
            };    
            // Busco pais para la nacionalidad
            let url =  `${BASE_URL}/api/paises/${data.pais}`;

            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` }
            });        
        
            formValues.PaisISO = response.data.data.Descripcion

            form.setFieldsValue(formValues);            
        }
        
        

        setLectorDNIVisible(false);
        // setOcupanteSeleccionado(null);
    
        // Recargar ocupantes para mostrar el nuevo DNI
        // await cargarOcupantes();
  };

  // Guardar particular
  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const token = localStorage.getItem('token');

      const formData = {
        ...values,
        FechaNacimiento: values.FechaNacimiento ? values.FechaNacimiento.format('YYYY-MM-DD') : null,
        FechaExpedicion: values.FechaExpedicion ? values.FechaExpedicion.format('YYYY-MM-DD') : null,
        CadTarjeta: values.CadTarjeta ? values.CadTarjeta.format('YYYY-MM-DD') : null,
      };

      setSaving(true);

      let response;
      if (currentCodParti && !isNew) {
        response = await axios.put(
          `${BASE_URL}/api/particulares/${currentCodParti}`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        await updateReservaLinea(currentCodParti);

        message.success('Particular actualizado correctamente');
      } else {
        if (!formData.Codigo) {
          const lastCode = await getLastCode();
          // console.log(" lastCode => ",lastCode);
          
          formData.Codigo = String(Number(lastCode) + 1).padStart(5, '0');
        }
        response = await axios.post(
          `${BASE_URL}/api/particulares`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        message.success('Particular creado correctamente');
      }

      const newCodParti = response.data.data.Codigo;
      // console.log(" newCodParti => ",newCodParti);
      
      await updateReservaLinea(newCodParti);

      if (onSuccess) {
        onSuccess(newCodParti, response.data.data);
      }

      onClose();

    } catch (error) {
      console.error('❌ Error guardando particular:', error);
      message.error(error.response?.data?.error || 'Error al guardar los datos');
    } finally {
      setSaving(false);
    }
  };

  const getLastCode = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/particulares/codigos/proximo-codigo`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      
      const data = response.data.data || [];

      // console.log(" data => ",data.proximoCodigo);
      
      return data.proximoCodigo;

      return '0';
    } catch (error) {
      console.error('❌ Error obteniendo último código:', error);
      return '0';
    }
  };

  const updateReservaLinea = async (codParti) => {
    try {
      const token = localStorage.getItem('token');
      const values = form.getFieldsValue();
      const nombreCompleto = `${values.Nombre1 || ''} ${values.Apellido1 || ''} ${values.Apellido2 || ''}`.trim();

      const payload = {
        CodParti: codParti,
        Nombre: nombreCompleto,
        Telefono: values.Telefono1 || '',
        Email: values.EMail || '',
        NIF: values.NIF || '',
        Nacion: values.PaisISO || '',
        Provincia: values.Provincia || '',
      };

      await axios.put(
        `${BASE_URL}/api/reservas/${numReserva}/linea/${linea}/ocupante/${numOcupante}/particular`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

    } catch (error) {
      console.error('❌ Error actualizando línea de reserva:', error);
    }
  };


  const handleDemoScan = async () => {
    const jsonDemo = {
      documento: {
        licenciaValidaHasta: "2025-12-31 01:00:00.000000000",
        resultado: 20546,
        tipo_documento: "D",
        numero_documento: "12345678X",
        numero_soporte:"AAA123123",
        nombre: "BERNARDO",
        apellido1: "PUDOL",
        apellido2: "GALOBRE",
        localidad_nacimiento: "BARCELONA",
        provincia_nacimiento: "BARCELONA",
        hijo_de: "JERONIMO MERCEDES",
        domicilio1: "C HEURES LES",
        domicilio2: "CABRERA DE MAR",
        domicilio3: "BARCELONA",
        domicilio4: "CATALU�A",
        codigo_ciudad: "08029",
        fecha_nacimiento: "24081964",
        fecha_expedicion: "01041997",
        fecha_validez: "31032007",
        nacionalidad: "ESP",
        pais: "ESP",
        sexo: "M",
        OCRB: "IDESP12345678X7<<<<<<<<<<<<<<<6408240M0703312ESP<<<<<<<<<<<0PUDOL<GALOBRE<<BERNARDO<<<<<<<",
        version: "10.4.8.418"
      }
    };

    const doc = jsonDemo.documento;



    const formValues = {
      TipoDocumento: doc.tipo_documento || '',
      NIF: doc.numero_documento || '',
      Nombre1: doc.nombre || '',
      Apellido1: doc.apellido1 || '',
      Apellido2: doc.apellido2 || '',
      FechaNacimiento: parseFecha(doc.fecha_nacimiento),
      FechaExpedicion: parseFecha(doc.fecha_expedicion),
      LugarNacimiento: doc.localidad_nacimiento || '',
      Direccion: doc.domicilio1 || '',
      Poblacion: doc.domicilio2 || '',
      CodPostal: doc.codigo_ciudad || '',
      Provincia: doc.provincia_nacimiento || '',
      Sexo: doc.sexo || '',
      PaisISO: doc.pais || '',
      Nacionalidad: doc.nacionalidad || '',
    };

    form.setFieldsValue(formValues);
    message.success('Datos cargados desde el escáner (demo)');
  }

  
  
  const handleScan = async () => {      
      setScanning(true);

      const parsearRespuesta = (texto) => {
        const matchError = texto.match(/<error>(-?\d+)/);
        const matchDesc = texto.match(/<description>([\s\S]*?)<\/description>/);
        const matchImagen = texto.match(/<imagen>([\s\S]*?)<\/imagen>/);
        const matchSiguientePagina = texto.match(/<necesita_siguiente_pagina>([\s\S]*?)<\/necesita_siguiente_pagina>/);

        return {
          codigo: matchError ? Number(matchError[1]) : null,
          descripcion: matchDesc ? matchDesc[1].trim() : '',
          imagen: matchImagen ? matchImagen[1].trim() : '',
          necesitaSiguientePagina: matchSiguientePagina
            ? matchSiguientePagina[1].trim() === '1'
            : false,
        };
      };
      try {
          const token = localStorage.getItem('token');      

          const responseDatos = await axios.get(`${BASE_URL}/api/dni_delta/datosEscaner/Escaner`,          
              { headers: { Authorization: `Bearer ${token}` } }
          );
          
          console.log(" Datos => ",responseDatos.data.data[0].IpEscaner);
          const datos = responseDatos.data.data[0];

          console.log(" datos escaner => ",datos);
          

          if (datos.IpEscaner){
              const iniciarEscaneo = async () => {
                try {
                  const url = `http://${datos.IpEscaner}/DltId/DltIdServer.dll?DltGetDocument?usuario=${datos.UsuarioEscaner}&pwd=${datos.PassEscaner}&tipoDocumento=0&nuevoEscaneo=1`;
                  // console.log(" url => ",url);
                  
                  const response = await axios.get(url,{timeout: 20000});
                  const data = response.data;
                 
                  const respuestaServidor = parsearRespuesta(data);

                  console.log(" respuestaServidor => ",respuestaServidor)

                  if (respuestaServidor.codigo === -2){
                    message.error(respuestaServidor.descripcion);
                  }else if(respuestaServidor.necesitaSiguientePagina){
                    const confirm = await new Promise((resolve) => {
                      Modal.confirm({
                          title: 'Leer documento',
                          content: 'Introduce la otra cara del documento',
                          okText: 'Sí, continuar',
                          cancelText: 'No, cancelar',
                          onOk: () => resolve(true),
                          onCancel: () => resolve(false)
                        });
                      });
        
                      if (!confirm) {
                          // setLoading(false);
                          return;
                      }

                      const url = `http://${datos.IpEscaner}/DltId/DltIdServer.dll?DltGetDocument?usuario=${datos.UsuarioEscaner}&pwd=${datos.PassEscaner}&tipoDocumento=0&nuevoEscaneo=0&modoPresentacion=2`;
                      // console.log(" url => ",url);
                  
                      const response = await axios.get(url,{timeout: 20000});
                      const data = response.data;

                      // console.log(" data => ",data);                  

                      handleDNIProcesado(data.documento)
                    

                  }

                  // console.log('Respuesta del servidor local:', );
                } catch (error) {
                  console.error('Error de red local/CORS:', error);
                }
              };

              console.log(' Inicio ');
              await iniciarEscaneo();   
              console.log(' Fin ');                    
          }
    } catch (error) {
        console.log(error);
        
        if (error.code === 'ECONNABORTED') {
          console.error('⏱️ Timeout: el escáner no respondió en 20 segundos');
          message.error('El escáner no ha respondido en 20 segundos.');
        } else {
          console.error('Error de red local/CORS:', error);
          message.error('No se pudo comunicar con el escáner.');
        }
    } finally {
      setScanning(false);
    }    

  };

  const handleSignature = () => {
    message.info('Función de firma (simulada)');
  };

const handleReiniciarParticular = () => {
    form.resetFields();
    setIsNew(true);
    message.info('Datos reiniciados');
  };

  const handleReset = () => {
    if (codParti && codParti !== '0' && codParti !== '') {
      loadParticular(codParti);
    } else {
      initializeFromReserva();
    }
    message.info('Datos restablecidos');
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <Spin size="large" />
          <p style={{ marginTop: 16 }}>Cargando datos del particular...</p>
        </div>
      );
    }

    return (
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          ListarDatos: true,
          MarcaMailing: false
        }}
        size="small"
      >
        {/* === BARRA DE ACCIONES === */}
        <Row gutter={8} style={{ marginBottom: 8 }}>
            <Col span={24}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  width: '100%'
                }}
              >
                <Button
                  icon={<ScanOutlined />}
                  onClick={() => abrirLectorDNI()}
                  loading={scanning}
                  size="small"
                >
                  Leer Documento
                </Button>

                <Select
                  style={{ width: 120 }}
                  placeholder="Seleccionar escáner"
                  value={escanerSeleccionado}
                  onChange={handleCambiarEscaner}
                >
                  {tiposEscaner.map(tipo => (
                    <Option
                      key={tipo.NombreEscaner}
                      value={tipo.NombreEscaner}
                      label={tipo.NombreEscaner}
                    >
                      {tipo.NombreEscaner}
                    </Option>
                  ))}
                </Select>

                <Button
                  icon={<SignatureOutlined />}
                  onClick={handleSignature}
                  size="small"
                >
                  Firma
                </Button>

                <Button
                  icon={<ReloadOutlined />}
                  onClick={handleReset}
                  size="small"
                >
                  Refrescar
                </Button>

                <Button
                  icon={<ReloadOutlined />}
                  onClick={handleReiniciarParticular}
                  size="small"
                >
                  Reiniciar particular
                </Button>
              </div>
            </Col>
          </Row>

        {/* === CONTEXTO DE LA RESERVA ===
        <Alert
          message="Contexto de la reserva"
          description={
            <Space size="small" wrap>
              <Tag color="blue" style={{ fontSize: 11 }}>R: {numReserva}</Tag>
              <Tag color="green" style={{ fontSize: 11 }}>L: {linea}</Tag>
              <Tag color="orange" style={{ fontSize: 11 }}>O: {numOcupante}</Tag>
              {fechaEntrada && (
                <Tag color="purple" style={{ fontSize: 11 }}>
                  <CalendarOutlined /> {dayjs(fechaEntrada).format('DD/MM/YYYY')}
                </Tag>
              )}
              {codParti && codParti !== '0' && (
                <Tag color="cyan" style={{ fontSize: 11 }}>Código: {codParti}</Tag>
              )}
            </Space>
          }
          type="info"
          showIcon
          style={{ marginBottom: 8, padding: '4px 12px' }}
        /> */}

        {/* === SECCIÓN 1: DOCUMENTO DE IDENTIDAD === */}
        <Card 
          title={<><IdcardOutlined /> Documento</>} 
          size="small"
          style={{ marginBottom: 6 }}
        >
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={8}>
              <Form.Item
                name="TipoDocumento"
                label="Tipo"
                rules={[{ required: true, message: 'Seleccione el tipo' }]}
                style={{ marginBottom: 4 }}
              >
                <Select placeholder="Tipo" allowClear size="small">
                  {tiposDocumento.map(t => (
                    <Option key={t.value} value={t.value}>{t.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="NIF"
                label="DNI / Pasaporte"
                rules={[{ required: true, message: 'Ingrese el documento' }]}
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="12345678Z" prefix={<IdcardOutlined />} size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="NumeroSoporte"
                label="Nº Soporte"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Número de soporte" size="small" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="FechaExpedicion"
                label="Fecha Expedición"
                style={{ marginBottom: 4 }}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format="DD/MM/YYYY"
                  placeholder="Seleccionar"
                  suffixIcon={<CalendarOutlined />}
                  size="small"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="FechaNacimiento"
                label="Fecha Nacimiento"
                rules={[{ required: true, message: 'Ingrese la fecha' }]}
                style={{ marginBottom: 4 }}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format="DD/MM/YYYY"
                  placeholder="Seleccionar"
                  suffixIcon={<CalendarOutlined />}
                  size="small"
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* === SECCIÓN 2: DATOS PERSONALES === */}
        <Card 
          title={
                <Space>
                  <UserOutlined /> Datos Personales
                  <Button
                    onClick={() => abrirModalBusqueda()}
                    icon={<SearchOutlined />}
                    size="small"
                    type="text" 
                  />
                </Space>
          } 
          size="small"
          style={{ marginBottom: 6 }}
        >
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={4}>
              <Form.Item
                name="Codigo"
                label="Código"
                // rules={[
                //   { pattern: /^[A-Z0-9]{1,5}$/, message: 'Máx. 5 caracteres' }
                // ]}
                style={{ marginBottom: 4 }}
              >
                <Input
                  placeholder="Código"
                  disabled={!isNew && currentCodParti}
                  prefix={<UserOutlined />}
                  maxLength={5}
                  style={{ textTransform: 'uppercase' }}
                  size="small"
                />           
              </Form.Item>
                
            </Col>
            <Col xs={24} sm={7}>
              <Form.Item
                name="Nombre1"
                label="Nombre"
                rules={[{ required: true, message: 'Ingrese el nombre' }]}
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Nombre" size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={7}>
              <Form.Item
                name="Apellido1"
                label="Primer Apellido"
                rules={[{ required: true, message: 'Ingrese el apellido' }]}
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Apellido 1" size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item
                name="Apellido2"
                label="Segundo Apellido"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Apellido 2" size="small" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={8}>
              <Form.Item
                name="Sexo"
                label="Sexo"
                rules={[{ required: true, message: 'Seleccione el sexo' }]}
                style={{ marginBottom: 4 }}
              >
                <Select placeholder="Sexo" allowClear size="small">
                  {tiposSexo.map(t => (
                    <Option key={t.value} value={t.value}>{t.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="LugarNacimiento"
                label="Lugar de Nacimiento"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Ciudad" size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="PaisISO"
                label="Nacionalidad"
                style={{ marginBottom: 4 }}
              >
                  <Select
                    showSearch
                    placeholder="Seleccione pais"
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {paises.map(pais => (
                      <Option key={pais.Codigo} value={pais.Descripcion} label={pais.Descripcion}>
                        {renderFlag(pais.CodigoISO)}
                        {pais.Descripcion}
                      </Option>
                    ))}
                  </Select>
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* === SECCIÓN 3: DIRECCIÓN Y CONTACTO (fusionados) === */}
        <Card 
          title={<><HomeOutlined /> Dirección y Contacto</>} 
          size="small"
          style={{ marginBottom: 6 }}
        >
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="Direccion"
                label="Domicilio"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Calle, número, piso" size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="Poblacion"
                label="Población"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Ciudad" size="small" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={6}>
              <Form.Item
                name="Provincia"
                label="Provincia"
                style={{ marginBottom: 4 }}
              >
                <Select placeholder="Provincia" allowClear showSearch size="small"
                    filterOption={(input, option) => {
                        return option.children.toLowerCase().includes(input.toLowerCase());
                    }}         
                    optionFilterProp="children"  
                >
                  {provincias.map(p => (
                    <Option key={p.value} value={p.value}>{p.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item
                name="CodPostal"
                label="Código Postal"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Código postal" size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item
                name="Telefono1"
                label="Teléfono"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Teléfono" prefix={<PhoneOutlined />} size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item
                name="EMail"
                label="E-Mail"
                rules={[{ type: 'email', message: 'Email inválido' }]}
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="email@dominio.com" prefix={<MailOutlined />} size="small" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 0]}>
            <Col xs={12} sm={6}>
              <Form.Item
                name="ListarDatos"
                label="Listar"
                valuePropName="checked"
                style={{ marginBottom: 4 }}
              >
                <Switch checkedChildren="Sí" unCheckedChildren="No" size="small" />
              </Form.Item>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Item
                name="MarcaMailing"
                label="Mailing"
                valuePropName="checked"
                style={{ marginBottom: 4 }}
              >
                <Switch checkedChildren="Sí" unCheckedChildren="No" size="small" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* === SECCIÓN 4: VISA / TARJETA ===
        <Card 
          title={<><CreditCardOutlined /> Visa / Tarjeta</>} 
          size="small"
          style={{ marginBottom: 6 }}
        >
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="Visa"
                label="Número de Visa"
                style={{ marginBottom: 4 }}
              >
                <Input placeholder="Número de tarjeta" size="small" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="CadTarjeta"
                label="Fecha Caducidad"
                style={{ marginBottom: 4 }}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format="MM/YYYY"
                  placeholder="MM/YYYY"
                  picker="month"
                  suffixIcon={<CalendarOutlined />}
                  size="small"
                />
              </Form.Item>
            </Col>
          </Row>
        </Card> */}

        {/* === SECCIÓN 5: CLASIFICACIÓN === */}
        <Card 
          title={<><TeamOutlined /> Clasificación</>} 
          size="small"
          style={{ marginBottom: 6 }}
        >
          <Row gutter={[8, 0]}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="TipoCliente"
                label="Tipo de Cliente"
                style={{ marginBottom: 4 }}
              >
                <Select placeholder="Tipo" allowClear size="small">
                  {tiposCliente.map(t => (
                    <Option key={t.value} value={t.value}>{t.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="TipoSegmentacion"
                label="Segmentación"
                style={{ marginBottom: 4 }}
              >
                <Select placeholder="Segmentación" allowClear size="small">
                  {tiposSegmentacion.map(t => (
                    <Option key={t.value} value={t.value}>{t.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* === SECCIÓN 6: OBSERVACIONES === */}
        <Card 
          title={<><FileTextOutlined /> Observaciones</>} 
          size="small"
          style={{ marginBottom: 6 }}
        >
          <Row gutter={[8, 0]}>
            <Col span={24}>
              <Form.Item
                name="Notas"
                label="Notas"
                style={{ marginBottom: 4 }}
              >
                <TextArea
                  rows={2}
                  placeholder="Observaciones adicionales"
                  maxLength={255}
                  showCount
                  style={{ fontSize: 12 }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* === ALERTA DE INFORMACIÓN === */}
        <Alert
          message="💡 Los campos con * son obligatorios. Use el escáner para leer el documento."
          type="info"
          showIcon
          style={{ padding: '4px 12px' }}
        />
      </Form>
    );
  };

  return (
    <>
    <Modal
      title={
        <Space size="small" wrap style={{ fontSize: 14 }}>
          <UserOutlined />
          <span>
            {isNew ? 'Nuevo Particular' : 'Editar Particular'}
            {codParti && codParti !== '0' && ` - ${codParti}`}
          </span>
          <Tag color="blue" style={{ fontSize: 11 }}>
            Reserva {numReserva} Línea {linea} Ocupante {numOcupante}
          </Tag>
        </Space>
      }
      open={visible}
      onCancel={onClose}
      width={900}
      footer={[
        <Button key="cancel" onClick={onClose} icon={<CloseOutlined />} size="small">
          Cancelar
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleSave}
          loading={saving}
          icon={<SaveOutlined />}
          size="small"
        >
          {isNew ? 'Crear' : 'Guardar'}
        </Button>
      ]}
      bodyStyle={{ 
        maxHeight: 'calc(100vh - 160px)', 
        overflowY: 'auto', 
        padding: '12px 16px' 
      }}
      destroyOnClose
    >
      {renderContent()}
    </Modal>

    
      <Modal
        title={'Buscar Particular'}
        open={modalBusquedaVisible}
        onCancel={() => setModalBusquedaVisible(false)}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        {/* Contenido del modal de búsqueda */}
        <Space direction="vertical" style={{ width: '100%' }}>
          {/* <Input.Search
            placeholder={`Buscar por código o nombre...`}
            value={filtroBusqueda}
            onChange={(e) => setFiltroBusqueda(e.target.value)}
            onSearch={(value) => buscarDatos(tipoBusqueda, value, 1)}
            style={{ marginBottom: 16 }}
          /> */}

          <Input.Search
            placeholder="Buscar por código o nombre..."
            value={filtroBusqueda}
            // onChange={(e) => {
            //   const value = e.target.value;
            //   setFiltroBusqueda(value);
            //   buscarDatos(tipoBusqueda, value, 1);
            // }}
            // onChange={handleBuscarChange}            
            onSearch={(value) => {
              // console.log('Buscando:', value);
              buscarDatos(value, 1);
            }}            
            onChange={handleBuscarLocal}
            style={{ marginBottom: 16 }}
            allowClear
          />          
          
          <Table
            columns={[
              { title: 'Código', dataIndex: 'Codigo', key: 'Codigo', width: 100 },
              { title: 'Nombre', dataIndex: 'Nombre', key: 'Nombre', ellipsis: true },
              { title: 'Teléfono', dataIndex: 'Telefono', key: 'Telefono', width: 120 },
              {
                title: 'Acción',
                key: 'accion',
                width: 80,
                render: (_, record) => (
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => seleccionarElemento(record)}
                  >
                    Seleccionar
                  </Button>
                ),
              },
            ]}
            dataSource={datosFiltrados}
            rowKey="Codigo"
            loading={cargandoBusqueda}
            pagination={paginacionBusqueda}
            onChange={(pagination) => {
              buscarDatos(filtroBusqueda, pagination.current);
            }}
            size="small"
          />
        </Space>
      </Modal>    

      <LectorDNIMobile
        visible={lectorDNIVisible}
        onClose={() => {
          setLectorDNIVisible(false);
          // setOcupanteSeleccionado(null);
        }}
        onSuccess={handleDNIProcesado}
        numReserva={numReserva}
        linea={linea}
        numOcupante={numOcupante}
        nombreCliente={nombreReserva}
        numHabitacion={numHabitacion}
        tipoAPI={tipoAPI}
      />


      </>
  );
};

export default ParticularModal;